<div class="modal-header">
  <h4 class="modal-title">Persisted message for item {{ row?.itemId }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="mb-3" *ngIf="row">
    <table class="table table-sm table-bordered mb-3">
      <tbody>
        <tr><th scope="row" style="width:180px">Reference ID</th><td>{{ row.referenceId }}</td></tr>
        <tr><th scope="row">Item ID</th><td>{{ row.itemId }}</td></tr>
        <tr *ngIf="row.supplierId"><th scope="row">Supplier ID</th><td>{{ row.supplierId }}</td></tr>
        <tr *ngIf="row.messageType"><th scope="row">Message Type</th><td>{{ row.messageType }}</td></tr>
        <tr *ngIf="row.source"><th scope="row">Source</th><td>{{ row.source }}</td></tr>
        <tr><th scope="row">Created</th><td>{{ row.createdDateTime }}</td></tr>
      </tbody>
    </table>
  </div>

  <ng-container *ngIf="loading">
    <div class="text-center py-3">
      <div class="spinner-border spinner-border-sm me-2" role="status"></div>
      Loading message content...
    </div>
  </ng-container>

  <ng-container *ngIf="error">
    <div class="alert alert-danger">{{ error }}</div>
  </ng-container>

  <ng-container *ngIf="!loading && !error && jsonData !== null">
    <div class="d-flex justify-content-end mb-2">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="copyToClipboard()">
        <i class="fa fa-copy" aria-hidden="true"></i> Copy to Clipboard
      </button>
    </div>
    <pre class="json-display" [innerHTML]="syntaxHighlightedContent"></pre>
  </ng-container>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Close</button>
</div>

<style>
  .json-display {
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 15px;
    max-height: 500px;
    overflow: auto;
    font-family: 'Courier New', Courier, monospace;
    font-size: 12px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  ::ng-deep .json-display .json-key {
    color: #881391;
    font-weight: bold;
  }

  ::ng-deep .json-display .json-string {
    color: #0b7500;
  }

  ::ng-deep .json-display .json-number {
    color: #1750eb;
  }

  ::ng-deep .json-display .json-boolean {
    color: #0000ff;
  }

  ::ng-deep .json-display .json-null {
    color: #808080;
  }

  /* XML highlighting */
  ::ng-deep .json-display .xml-bracket {
    color: #0000cc;
    font-weight: bold;
  }

  ::ng-deep .json-display .xml-element {
    color: #000080;
    font-weight: bold;
  }

  ::ng-deep .json-display .xml-attr-name {
    color: #994500;
  }

  ::ng-deep .json-display .xml-attr-value {
    color: #1a1aa6;
    font-weight: bold;
  }

  ::ng-deep .json-display .xml-comment {
    color: #808080;
    font-style: italic;
  }

  ::ng-deep .json-display .xml-decl {
    color: #606060;
  }

  ::ng-deep .json-display .xml-pi-delim {
    color: #ff0000;
    background-color: #ffff00;
    font-weight: bold;
  }

  ::ng-deep .json-display .xml-pi-attr-name {
    color: #ff0000;
  }

  ::ng-deep .json-display .plain-text {
    color: #000000;
  }
</style>
